/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import Flex from '@atlaskit/primitives/components/flex';
import Box from '@atlaskit/primitives/box';
import Stack from '@atlaskit/primitives/stack';
import { xcss } from '@atlaskit/primitives/xcss';
import { token } from '@atlaskit/tokens';

export const Skeleton = (): React.JSX.Element => (
	<Box xcss={containerStyles}>
		<Flex gap="space.100" alignItems="center">
			<Box xcss={backButton} />
			<Box xcss={headingSkeleton} />
		</Flex>

		<Stack space="space.100" grow="hug">
			<Box xcss={menuItem} />
			<Box xcss={menuItem} />
			<Box xcss={menuItem} />
			<Box xcss={menuItem} />
			<Box xcss={menuItem} />
			<Box xcss={menuItem} />
		</Stack>
	</Box>
);

const containerStyles = xcss({
	paddingBlock: 'space.200',
	paddingInline: 'space.200',
});

const backButton = xcss({
	backgroundColor: 'color.skeleton',
	width: token('space.300'),
	height: token('space.300'),
	borderRadius: 'radius.small',
});

const headingSkeleton = xcss({
	backgroundColor: 'color.skeleton',
	height: token('space.300'),
	borderRadius: 'radius.small',
	flex: 1,
});

const menuItem = xcss({
	backgroundColor: 'color.skeleton',
	height: token('space.400'),
	borderRadius: 'radius.small',
});
